import React, { Component } from "react";
import firebase from "../firebase";
import { ApiUrl, EviusUrl } from "../constants";
import FirebaseAuth from "react-firebaseui/FirebaseAuth";

import icon from "./../icon.svg";
var firebaseui = require("firebaseui");

const uiConfig = {
  //POPUP Facebook/Google
  signInFlow: "popup",
  //The list of providers enabled for signing
  signInOptions: [
    /* firebase.auth.GoogleAuthProvider.PROVIDER_ID, */
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
  ],
  //Prevent redirect
  callbacks: { signInSuccessWithAuthResult: () => false },
  credentialHelper: "none",
  tosUrl: `${EviusUrl}/terms`,
  privacyPolicyUrl: `${EviusUrl}/privacy`,
};

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    user.getIdToken().then(function(idToken) {
      window.location.replace(
        `${ApiUrl}?evius_token=${idToken}&refresh_token=${user.refreshToken}`
      );
    });
  }
});

class Login extends Component {
  state = { isSignedIn: false, loading: true };

  componentDidMount() {
    this.setState({ loading: false });
  }

  render() {
    const { user, loading } = this.state;
    const language = navigator.language.slice(0, 2);
    console.log(user);
    return (
      <div className="login">
        <div className="login-form">
          <div className="login-title">
            <a href="https://evius.co">
              <img className="icon-title" src={icon} alt="Ingreso" href="https://evius.co"/>
            </a>
            
          </div>
          <div className="login-auth">
            {loading ? (
              <div>Loading</div>
            ) : (
              <FirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
            )}
          </div>
          <div>
            <a href="https://evius.co">
              <button className="firebaseui-id-submit firebaseui-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored">Regresar a evius</button>
            </a>
          </div>
          <div className="login-footer">
            <span>© 2001-2020 All Rights Reserved - <a href="https://evius.co">EVIUS.co</a></span>
          </div>
        </div>
        <div className="login-video">
          <video
            className="video-container video-container-overlay"
            autoPlay={true}
            muted={true}
            data-reactid=".0.1.0.0">
            <source type="video/mp4" src="/intro-mocion.mp4" />
          </video>
        </div>
      </div>
    );
  }
}

export default Login;
